import Icon from '../components/Icon.vue'

Icon.register({
  'list-ul': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M96 96C96 122.5 74.5 144 48 144S0 122.5 0 96 21.5 48 48 48 96 69.5 96 96zM48 208C21.5 208 0 229.5 0 256S21.5 304 48 304 96 282.5 96 256 74.5 208 48 208zM48 368C21.5 368 0 389.5 0 416S21.5 464 48 464 96 442.5 96 416 74.5 368 48 368zM144 132H496C504.8 132 512 124.8 512 116V76C512 67.2 504.8 60 496 60H144C135.2 60 128 67.2 128 76V116C128 124.8 135.2 132 144 132zM144 292H496C504.8 292 512 284.8 512 276V236C512 227.2 504.8 220 496 220H144C135.2 220 128 227.2 128 236V276C128 284.8 135.2 292 144 292zM144 452H496C504.8 452 512 444.8 512 436V396C512 387.2 504.8 380 496 380H144C135.2 380 128 387.2 128 396V436C128 444.8 135.2 452 144 452z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/list-ul.js
// module id = 4ANk
// module chunks = 144